import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Sparte } from '@mwe/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductIconsComponent } from '../../product-icons/product-icons.component';

@Component({
  selector: 'mwe-clickable-products-card',
  templateUrl: './clickable-products-card.component.html',
  imports: [TranslatePipe, ProductIconsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClickableProductsCardComponent {
  readonly cardClicked = output();
  categories = input<Sparte[]>();
  ariaTitle = input<string>();
  dataTest = input<string>();
  hasAutoFocus = input<boolean>(false);
}
